import { useConfigurationStore } from '../shared/stores/useConfigurationStore';
import { useSharedParameterStore } from '../shared/stores/useSharedParameterStore';
import { useQuickFillStore } from '../shared/stores/useQuickFillStore';
import { useParameterWorkflowStore } from '../shared/stores/useParameterWorkflowStore';
import { usePcfValidationStore } from '../shared/stores/usePcfValidationStore';
import { useRevitStore } from '../shared/stores/useRevitStore';

export const deferredPersistedStores = [
  useConfigurationStore,
  useSharedParameterStore,
  useQuickFillStore,
  useParameterWorkflowStore,
  usePcfValidationStore,
  useRevitStore,
];
